import React, { Component, PropTypes } from 'react';
import axios from 'axios';
import { Col, ControlLabel, FormGroup } from 'react-bootstrap';
import config from '../../../../config/config';

const appUrlPath = `/${config.appUrlPath}`;

class Nationality extends Component {

  constructor(props) {
    super(props);
    this.state = {
      option: [],
      isDataLoaded: false
    }
  }

  componentWillMount() {
    axios.get(`${appUrlPath}/getCountry`, {
      params: {}
    })
    .then((res) => {
      this.setState({ option: res.data, isDataLoaded: true });
    })
    .catch(() => {
    });
  }

  render() {
    return (
      <FormGroup>
        <Col componentClass={ControlLabel} sm={5}>
          Nationality *
        </Col>
        <Col sm={7}>
            {this.state.isDataLoaded ?
              <select
                className="custom-select"
                name="nationality"
                onChange={this.props.handleChangeNationality}
                value={this.props.nationality}
              >
                <option value="">Please select</option>
                {this.state.option.map((obj, index) => {
                  const counter = index
                  return (
                    <option
                      value={obj.code}
                      key={counter}
                    >{obj.name}</option>
                  );
                })}
              </select> : <div>Loading</div>}

        </Col>
      </FormGroup>
    )
  }
}

Nationality.propTypes = {
  handleChangeNationality: PropTypes.func,
  nationality: PropTypes.string
};

export default Nationality;



// WEBPACK FOOTER //
// ./src/app/components/quotationPVComponent/nationality/Nationality.js